var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66667C6.77508 1.66667 4.16675 4.27501 4.16675 7.50001C4.16675 11.875 10.0001 18.3333 10.0001 18.3333C10.0001 18.3333 15.8334 11.875 15.8334 7.50001C15.8334 4.27501 13.2251 1.66667 10.0001 1.66667ZM5.83341 7.50001C5.83341 5.20001 7.70008 3.33334 10.0001 3.33334C12.3001 3.33334 14.1667 5.20001 14.1667 7.50001C14.1667 9.90001 11.7667 13.4917 10.0001 15.7333C8.26675 13.5083 5.83341 9.87501 5.83341 7.50001Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.58334C11.1507 9.58334 12.0834 8.6506 12.0834 7.50001C12.0834 6.34941 11.1507 5.41667 10.0001 5.41667C8.84949 5.41667 7.91675 6.34941 7.91675 7.50001C7.91675 8.6506 8.84949 9.58334 10.0001 9.58334Z",
    fill: "#A3A3A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.5d5bc9be8993bc932281e4ee178a89d1.svg";
export { ForwardRef as ReactComponent };